import { useLocation, useParams } from 'react-router-dom'

/**
 * Whether the current route is "inside a room", used to decide whether to show
 * the floating game controls and room-scoped navigation.
 *
 * Charter Classes are explicitly excluded. They carry a `:roomId` param like
 * any room, but they have no rounds, phases or timer — the backend refuses
 * every game action on one — so surfacing game controls there would offer
 * buttons that can only fail.
 */
const CHARTER_CLASS_PATH = /^\/charter-classes(\/|$)/
const STUDENT_CLASS_PATH = /^\/player-dashboard\/[A-Z0-9]+\/class(\/|$)/

export const useRoomDetection = () => {
  const location = useLocation()
  const params = useParams()

  const isCharterClassRoute =
    CHARTER_CLASS_PATH.test(location.pathname) ||
    STUDENT_CLASS_PATH.test(location.pathname)

  const hasRoomId =
    !isCharterClassRoute &&
    !!(
      location.pathname.match(/\/rooms\/[A-Z0-9]{10}/) ||
      location.pathname.match(/\/prof-dashboard\/[A-Z0-9]{10}/) ||
      params.roomId
    )

  const roomId = params.roomId as string | undefined

  return {
    hasRoomId,
    roomId,
    isCharterClassRoute,
    pathname: location.pathname,
  }
}
